import { useEffect, useRef, useState } from 'react';
export function scrollNodeTo(node, x, y) {
    node === null || node === void 0 ? void 0 : node.scrollTo({
        top: y !== null && y !== void 0 ? y : 0,
        left: x !== null && x !== void 0 ? x : 0,
        behavior: 'smooth',
    });
}
export function useScrollable() {
    var _a, _b;
    const [isScrollableX, setIsScrollableX] = useState(false);
    const [isScrollableY, setIsScrollableY] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const [scrollX, setScrollX] = useState(0);
    const handleNodeScroll = (event) => {
        setScrollY(event.target.scrollTop);
        setScrollX(event.target.scrollLeft);
    };
    const scrollableRef = useRef(null);
    const clientWidth = (_b = (_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
    const controllersWidth = 80;
    const scrollSize = clientWidth - controllersWidth;
    const maxScrollX = scrollableRef.current
        ? scrollableRef.current.scrollWidth -
            (scrollableRef.current.clientWidth - controllersWidth)
        : 0;
    const scrollToLeft = () => {
        var _a;
        if (!scrollableRef.current)
            return;
        const position = ((_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) - scrollSize;
        scrollNodeTo(scrollableRef.current, position >= 0 ? position : 0);
    };
    const scrollToRight = () => {
        var _a;
        if (!scrollableRef.current)
            return;
        const position = ((_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) + scrollSize;
        scrollNodeTo(scrollableRef.current, position >= maxScrollX ? maxScrollX : position);
    };
    useEffect(() => {
        const node = scrollableRef.current;
        if (!node)
            return;
        setIsScrollableX(node.scrollWidth > (node === null || node === void 0 ? void 0 : node.clientWidth));
        setIsScrollableY(node.scrollHeight > (node === null || node === void 0 ? void 0 : node.clientHeight));
        node === null || node === void 0 ? void 0 : node.addEventListener('scroll', handleNodeScroll);
        const resizeObserver = new ResizeObserver(() => {
            setIsScrollableX(node.scrollWidth > (node === null || node === void 0 ? void 0 : node.clientWidth));
            setIsScrollableY(node.scrollHeight > (node === null || node === void 0 ? void 0 : node.clientHeight));
        });
        (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && resizeObserver.observe(scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current);
        return () => {
            node === null || node === void 0 ? void 0 : node.removeEventListener('scroll', handleNodeScroll);
            resizeObserver.disconnect();
        };
    }, [
        scrollX,
        scrollY,
        isScrollableX,
        isScrollableY,
        clientWidth,
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current,
    ]);
    return {
        scrollableRef,
        scrollX,
        scrollY,
        isScrollableX,
        isScrollableY,
        scrollToLeft,
        scrollToRight,
    };
}
//# sourceMappingURL=useScrollable.js.map